/* SS Attribution (site-wide). Load once in theme.liquid <head>.
   Stores first touch (never overwritten) and last touch (updated on any new campaign/referrer visit).
   API: window.ssAttribution.first(), .flat() (last touch), .log() */
(function () {
  if (window.ssAttribution) return;
  var SITE_HOST = 'mymanor.london';
  var FT = 'ss_attr_ft', LT = 'ss_attr_lt', LOG = 'ss_attr_log';
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid', 'msclkid', 'ttclid', 'li_fat_id'];
  function get(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function cookie(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
  function sourceFromReferrer(ref) {
    if (!ref) return { source: '(direct)', medium: '(none)' };
    var h = '';
    try { h = new URL(ref).hostname.replace(/^www\./, ''); } catch (e) { return { source: '(direct)', medium: '(none)' }; }
    if (h.indexOf(SITE_HOST) > -1) return null; // internal navigation
    if (/google\.|bing\.|duckduckgo\.|yahoo\.|ecosia\./.test(h)) return { source: h.split('.')[0], medium: 'organic' };
    if (/facebook\.|instagram\.|t\.co|twitter\.|x\.com|linkedin\.|tiktok\./.test(h)) return { source: h.split('.')[0], medium: 'social' };
    return { source: h, medium: 'referral' };
  }
  function capture() {
    var p = new URLSearchParams(location.search), t = { ts: new Date().toISOString(), landing_page: location.origin + location.pathname, referrer: document.referrer || '' };
    var hasParams = false;
    KEYS.forEach(function (k) { var v = p.get(k); if (v) { t[k] = v; hasParams = true; } });
    if (!hasParams) {
      var r = sourceFromReferrer(document.referrer);
      if (!r) return; // internal page view, keep existing touches
      t.utm_source = r.source; t.utm_medium = r.medium;
      if (r.source === '(direct)' && get(LT)) return; // direct return visit: keep last real touch
    }
    if (!t.utm_source) t.utm_source = t.gclid ? 'google' : t.fbclid ? 'facebook' : t.msclkid ? 'bing' : '(not set)';
    if (!t.utm_medium) t.utm_medium = (t.gclid || t.fbclid || t.msclkid) ? 'cpc' : '(not set)';
    if (!get(FT)) set(FT, t);
    set(LT, t);
    var log = get(LOG) || []; log.push([t.ts.slice(0, 16), t.utm_source, t.utm_medium, t.utm_campaign || '', t.landing_page.replace(location.origin, '')]);
    set(LOG, log.slice(-15));
  }
  capture();
  window.ssAttribution = {
    first: function () { return get(FT) || {}; },
    flat: function () { var t = get(LT) || {}; t.fbp = cookie('_fbp'); t.fbc = cookie('_fbc'); t.ga = cookie('_ga'); return t; },
    log: function () { return JSON.stringify(get(LOG) || []); }
  };
})();
